import { KeysToCamelCase, TableColumn } from '@statsbomb/parachute-types';
import { ITEMS_PER_PAGE } from '@/consts/interface';

export type DataTableColumn = KeysToCamelCase<TableColumn> & { is360: boolean; isPhysical: boolean };

type ColumnGroupHeader = {
  translationKey: string;
  translationNs: string;
};

export type ColumnOption = {
  value: string;
  label: {
    translationKey: string;
    translationKeyLong?: string;
    translationNs: string;
  };
  is360: boolean;
  isCore: boolean;
  isPhysical: boolean;
};

export type ColumnSubGroup = {
  header: ColumnGroupHeader;
  options: ColumnOption[];
};

export type ColumnGroup = {
  header: ColumnGroupHeader;
  options: ColumnSubGroup[];
};

export type ItemsPerPage = (typeof ITEMS_PER_PAGE)[number];

export enum TableColumnsEditorTabs {
  COLUMN_SELECT = 'column-select',
  COLUMN_SORT = 'column-sort',
}

// Table IDs to assign to tables. These are saved to the config when the user edits/saves table columns
export enum TableId {
  PLAYER_AGGS = 'playerAggs',
  PLAYER_GAMES_GK = 'playerGamesGK',
  PLAYER_GAMES_OUTFIELD = 'playerGamesOutfield',
  PLAYER_EVENTS = 'playerEvents',
  TEAM_AGGS = 'teamAggs',
  TEAM_GAMES = 'teamGames',
  TEAM_EVENTS = 'teamEvents',
  TEAM_SQUAD = 'teamSquad',
  EVENT_DATA = 'eventData',
}
